import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { Check } from "lucide-react";

const CAPABILITIES = [
  "Invite existing drivers", "Connect with RelayRigs drivers", "Create preferred driver lists", "Create driver groups",
  "Organize drivers by region", "Organize by equipment experience", "Organize by endorsements", "Organize by availability",
  "Track previous assignments", "Send private opportunities", "Maintain broker-specific driver relationships",
];

export const BrokerDriverNetwork = () => (
  <section id="broker-driver-network" data-testid="broker-driver-network-section" className="py-24 md:py-32 bg-rr-surface">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Your Network" title="Your Driver Network. Built Inside RelayRigs." testId="broker-driver-network" />
      <RevealStagger className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {CAPABILITIES.map((c) => (
          <RevealItem key={c}>
            <div data-testid={`broker-network-capability-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-start gap-2.5 bg-white border border-rr-line rounded-lg px-4 py-3.5 text-sm font-semibold text-rr-navy">
              <Check size={16} className="text-rr-orange shrink-0 mt-0.5" /> {c}
            </div>
          </RevealItem>
        ))}
      </RevealStagger>
      <p className="text-xs text-rr-muted mt-6 max-w-2xl">
        Adding a driver to a broker network does not create an employment relationship. Drivers keep their own RelayRigs account and choose which opportunities to accept.
      </p>
    </div>
  </section>
);
